import features from '@/http/requests/features';

export default {
    fetch({ commit }) {
        return new Promise((resolve, reject) => {
            features.fetch().then((response) => {
                commit('SET_FEATURES', response.data.data.getFeature);
                commit('SET_ASSEMBLED', true);
                resolve(response);
            }).catch((exception) => {
                reject(exception);
            });
        })
    }
}
